export default {
  name: 'Phoenix Global Forum',
  shortName: 'Phoenix',
  description:
    "Le Phoenix Global Forum est organisé par le FEIA en association avec Phoenix Sister Cities. En tant que ville à la croissance la plus rapide des États-Unis depuis cinq ans, la région émerge rapidement comme une plaque tournante pour les organisations des secteurs des biosciences, de la technologie, de la durabilité et de la défense ; attirant d'importants investissements extérieurs dans la région et créant un écosystème d'entreprises prometteur.",
  thumbnail: '/images/events/phoenix/thumbnail-phoenix.jpg',
  link: 'https://www.phoenixglobalforum.com/',
  header: {
    content:
      "Le Phoenix Global Forum est organisé par le FEIA en association avec Phoenix Sister Cities. En tant que ville à la croissance la plus rapide des États-Unis depuis cinq ans, la région émerge rapidement comme une plaque tournante pour les organisations des secteurs des biosciences, de la technologie, de la durabilité et de la défense ; attirant d'importants investissements extérieurs dans la région et créant un écosystème d'entreprises prometteur."
  },
  bullets: {
    bullet1: {
      number: '1',
      label: 'Édition'
    },
    bullet2: {
      number: '0',
      label: 'Participants'
    },
    bullet3: {
      number: '0',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '0',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'Le Phoenix Global Forum servira de plateforme où les décideurs, les leaders d’opinion et les experts dans leurs domaines respectifs se réuniront pour discuter de l’évolution des besoins de la société dans le contexte des défis mondiaux actuels. Le forum examinera les solutions déjà en cours de développement, tant à Phoenix que dans le monde entier, tout en encourageant l’innovation future par le biais de la connexion et de la collaboration. '
  },
  next: {
    title: 'Forging The Future',
    content:
      "La première édition du Phoenix Global Forum se penchera sur la coopération internationale et l'innovation stratégique nécessaires pour relever les nouveaux défis mondiaux. Des dirigeants du monde des affaires, du gouvernement et du secteur académique se réuniront pour discuter de ces défis et des opportunités qui en découlent et qui peuvent assurer une croissance et une compétitivité continues. Le Phoenix Global Forum aura lieu le 2 mai 2024 à l'hôtel Arizona Biltmore."
  },
  gallery: {
    title: 'Galerie de photos',
    edition11: {
      title: '11ème édition — Investing in Trust',
      index: [
        {
          image: '/images/events/miami/gallery/12th-miami-001.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-002.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-003.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-004.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-005.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-006.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-007.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-008.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-009.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-010.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-011.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-012.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-013.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-014.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-015.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-016.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-017.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-018.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-019.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-020.jpg'
        },
        {
          image: '/images/events/miami/gallery/12th-miami-021.jpg'
        }
      ]
    }
  }
}
